<script lang="ts" setup>
import { marked } from 'marked'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    title: string
    width?: number
    iconSize?: 'small' | 'medium' | 'large'
    markdownContent?: string
    zIndex?: number
  }>(),
  {
    width: 400,
    iconSize: 'medium',
    markdownContent: '',
    zIndex: undefined,
  }
)

const iconSizeClass = computed(() => {
  switch (props.iconSize) {
    case 'small':
      return 'text-sm'
    case 'medium':
      return 'text-lg'
    case 'large':
      return 'text-xl'
    default:
      return 'text-lg'
  }
})

const renderedContent = computed(() => {
  if (props.markdownContent) {
    return marked(props.markdownContent, { async: false })
  }
  return ''
})
</script>

<template>
  <div>
    <el-popover
      placement="top-start"
      :width="width"
      trigger="hover"
      effect="dark"
      :z-index="zIndex"
      content="this is content, this is content, this is content"
    >
      <template #reference>
        <i-mdi:help-circle
          class="align-middle"
          :class="[iconSizeClass]"
          v-bind="$attrs"
        />
      </template>
      <template #default>
        <div class="help-text">
          <h3 class="font-bold text-lg text-center mb-2 break-normal">
            {{ props.title }}
          </h3>
          <div class="indent-sm break-normal text-left">
            <div v-if="renderedContent" v-html="renderedContent"></div>
            <slot v-else />
          </div>
        </div>
      </template>
    </el-popover>
  </div>
</template>

<style lang="scss">
.help-text {
  @apply break-words text-sm;

  p {
    @apply mb-1.5 leading-relaxed;
  }
  ol {
    @apply list-decimal list-outside ml-4 mb-1 pl-0.4 mt-0;
  }
  ul {
    @apply list-disc list-outside ml-4 mb-1 pl-0.4 mt-0;
  }
  li {
    @apply mb-0.5 leading-tight ml-0 pl-0.2 break-words;
  }
  a {
    @apply underline;
  }
}
</style>
